import { combineReducers } from "redux";
import * as actionTypes from "./types";
import { createReducer } from "../../../utils";

/* State shape
{
  spots: [],
  vehicles: [],
  establishments: [],
  products: [],
  customers: [],
  model: string
  isLoading: bool
}
*/
const initialPage = {
  isInit         : false,
  isLoading      : true,
  spots          : [],
  vehicles       : [],
  establishments : [],
  products       : [],
  customers      : [],
  savCategories  : {},
  savCategoriesGrouped: [],
  vigilanceLevels: {},
  smsModel       : ''
};
const savReducer = createReducer(initialPage)({

  [actionTypes.INIT_ADMIN_SAV]: (state, action) => {
    return initialPage;
  },

  [actionTypes.INIT_ADMIN_SAV_COMPLETED]: (state, action) => {
    return { ...state,
      spots          : action.payload.result.spots,
      vehicles       : action.payload.result.vehicles,
      establishments : action.payload.result.establishments,
      products       : action.payload.result.products,
      customers      : action.payload.result.customers,
      savCategories  : action.payload.result.savCategories || {},
      savCategoriesGrouped: action.payload.result.savCategoriesGrouped || [],
      vigilanceLevels: action.payload.result.vigilanceLevels || {},
      smsModel       : action.payload.result.model,
      isLoading      : false,
      isInit         : true
    };
  },

  [actionTypes.SAV_SEND_SMS]: (state, action) => {
    return { ...state, isLoading: true };
  },
  [actionTypes.SAV_SEND_SMS_COMPLETED]: (state, action) => {
    return { ...state, isLoading: false, data: action.payload.result };
  },
  [actionTypes.SAV_SEND_SMS_FAILED]: (state, action) => {
    return { ...state, isLoading: false };
  },

  [actionTypes.SAV_CREDIT_POOLS]: (state, action) => {
    return { ...state };
  },
  [actionTypes.SAV_CREDIT_POOLS_COMPLETED]: (state, action) => {
    return { ...state, isLoading: false, data: action.payload.result };
  },
  [actionTypes.SAV_CREDIT_POOLS_FAILED]: (state, action) => {
    return { ...state, isLoading: false };
  },

});

const initialProps = {
  items: [],
  categories: [],
  savCategories: {},
  savCategoriesGrouped: [],
  vigilanceLevels: {},
  responseTemplates: [],
  customerHistory: null,
  compensationSuggestion: null,
  freshdeskTicket: null,
  responsePreview: '',
  isLoading: false,
};
const propReducer = createReducer(initialProps)({
  [actionTypes.SAV_PROP_LIST]: (state) => ({ ...state, isLoading: true }),
  [actionTypes.SAV_PROP_LIST_COMPLETED]: (state, action) => ({
    ...state,
    isLoading: false,
    items: action.payload.result.items || []
  }),
  [actionTypes.SAV_PROP_LIST_FAILED]: (state) => ({ ...state, isLoading: false }),

  [actionTypes.SAV_PROP_CREATE]: (state) => ({ ...state, isLoading: true }),
  [actionTypes.SAV_PROP_CREATE_COMPLETED]: (state, action) => ({
    ...state,
    isLoading: false,
    items: [action.payload.result.item, ...state.items]
  }),
  [actionTypes.SAV_PROP_CREATE_FAILED]: (state) => ({ ...state, isLoading: false }),

  [actionTypes.SAV_PROP_CANCEL_COMPLETED]: (state, action) => ({
    ...state,
    items: state.items.map(p => p.id === action.payload.result.item.id ? action.payload.result.item : p)
  }),

  [actionTypes.SAV_PROP_CATEGORIES_COMPLETED]: (state, action) => ({
    ...state,
    categories: action.payload.result.items || [],
    savCategories: action.payload.result.savCategories || {},
    savCategoriesGrouped: action.payload.result.savCategoriesGrouped || [],
    vigilanceLevels: action.payload.result.vigilanceLevels || {}
  }),

  [actionTypes.SAV_PROP_CUSTOMER_HISTORY_COMPLETED]: (state, action) => ({
    ...state,
    customerHistory: action.payload.result.item || null
  }),

  [actionTypes.SAV_PROP_COMPENSATION_SUGGESTION_COMPLETED]: (state, action) => ({
    ...state,
    compensationSuggestion: action.payload.result.item || null
  }),

  [actionTypes.SAV_PROP_RESPONSE_TEMPLATES_COMPLETED]: (state, action) => ({
    ...state,
    responseTemplates: action.payload.result.items || []
  }),

  [actionTypes.SAV_PROP_FRESHDESK]: (state) => ({ ...state, isLoading: true }),
  [actionTypes.SAV_PROP_FRESHDESK_COMPLETED]: (state, action) => ({
    ...state,
    isLoading: false,
    freshdeskTicket: action.payload.result.item || null
  }),
  [actionTypes.SAV_PROP_FRESHDESK_FAILED]: (state) => ({ ...state, isLoading: false, freshdeskTicket: null }),

  [actionTypes.SAV_PROP_RESPONSE_PREVIEW_COMPLETED]: (state, action) => ({
    ...state,
    responsePreview: (action.payload.result.item || {}).text || ''
  }),
});

export default combineReducers({
  admin: savReducer,
  propositions: propReducer,
});
